export enum DateTimeDisplayMode {
  Countdown = 'countdown',
  Date = 'date',
  DateKey = 'date-key',
  DateTime = 'datetime',
  DateTimeAmPm = 'datetime-ampm',
  DateTimeWithSeconds = 'datetime-with-seconds',
  DayMonth = 'day-month',
  FilenameStamp = 'filename-stamp',
  Rfc3339 = 'rfc3339',
  UnixSeconds = 'unix-seconds',
}
